module.exports = __webpack_public_path__ + "media/correct.dd76ca28.mp3";